import { render, staticRenderFns } from "./message-recharge.vue?vue&type=template&id=5dc90883&scoped=true"
import script from "./message-recharge.vue?vue&type=script&lang=ts"
export * from "./message-recharge.vue?vue&type=script&lang=ts"
import style0 from "./message-recharge.vue?vue&type=style&index=0&id=5dc90883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc90883",
  null
  
)

export default component.exports